import { Entry, isEntry } from '../entries';
import { Block } from './blocks';

export const handleArticleDisclaimerStatement = (blocks: Block[], entry?: Entry): Block[] => {
  if (
    !isEntry(entry, 'article') ||
    !(entry.contentTypeCategorySingle?.slug === 'insight') ||
    !entry.articleDisclaimer
  )
    return blocks;

  const hasArticleDisclaimerBlock = blocks.some(
    (block) => block.__typename === 'blocks_articleDisclaimerStatement_BlockType',
  );

  if (hasArticleDisclaimerBlock) return blocks;

  const articleDisclaimer: Block<'blocks_articleDisclaimerStatement_BlockType'> = {
    __typename: 'blocks_articleDisclaimerStatement_BlockType',
    id: 'article-disclaimer-statement',
  };

  // Insert the disclaimer just above the LAST profile cards (contact) block. If there is no contact block at
  // all, append the disclaimer to the very bottom.
  const lastProfileCardsIndex = blocks.findLastIndex(
    (block) => block.__typename === 'blocks_profileCards_BlockType',
  );

  if (lastProfileCardsIndex === -1) {
    blocks.push(articleDisclaimer);
  } else {
    blocks.splice(lastProfileCardsIndex, 0, articleDisclaimer);
  }

  return blocks;
};
